import { Outlet } from "react-router-dom";

import {
  SidebarInset,
  SidebarProvider,
} from "@ospra/design-system/components/sidebar";

import { AppSidebar } from "../components/appSidebar";

export function DashboardLayout() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="overflow-hidden! h-[calc(100svh-10px)]">
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  );
}
